import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init(){
        this.backButton = this.el;
        this.backButton.addEventListener('click', this.goBack.bind(this));
    }

    goBack(){
        window.history.back();
    }
}
